import { create } from "zustand";

interface StoreState {
  services: [];
  setServices: (services) => void;
}

export const useServicesStore = create<StoreState>((set) => ({
  services: [],
  setServices: (services) => set(() => ({ services }))
}));
